'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'spinner';
  return 'brsk-' + name;
};


//////////////////
// WEBPACK FOOTER
// ./~/better-react-spinkit/dist/util/animationName.js
// module id = 592
// module chunks = 0